// Configuration for different environments
const config = {
  // Always use production API URL directly (backend has CORS * enabled)
  environment: 'production',

  // API base URLs
  local: {
    apiBaseUrl: 'https://tartalk.mycartly.in',
    imageBaseUrl: 'https://tartalk.mycartly.in/'
  },

  production: {
    apiBaseUrl: 'https://tartalk.mycartly.in',
    imageBaseUrl: 'https://tartalk.mycartly.in/'
  }
};

// Get current environment config
const getConfig = () => {
  return config[config.environment] || config.local;
};

// Get API base URL
export const API_BASE_URL = getConfig().apiBaseUrl;

// Verify OTP endpoint (override with REACT_APP_VERIFY_OTP_URL if backend uses e.g. /api/verifyOTP)
export const VERIFY_OTP_URL = process.env.REACT_APP_VERIFY_OTP_URL || `${API_BASE_URL}/verifyOTP`;

// Get image base URL
export const IMAGE_BASE_URL = getConfig().imageBaseUrl;

// Helper function to get product image URL
export const getProductImageUrl = (product) => {
  if (!product || !product.product_id) return null;

  const storeId = product.product_id.toString().substring(0, 7);
  const timestamp = new Date().getTime();

  // Use the primary image version if set, otherwise default to v1
  const version = product.primary_image_version || 1;

  // Use localhost for images since we have them locally
  return `${IMAGE_BASE_URL}uploads/products/${storeId}/${product.product_id}_v${version}.png?t=${timestamp}`;
};

// Helper function to get blog image URL
export const getBlogImageUrl = (blog) => {
  if (!blog || !blog.has_image || !blog.image_url) return null;

  const timestamp = new Date().getTime();

  // Use localhost for images since we have them locally
  return `${IMAGE_BASE_URL}${blog.image_url}?t=${timestamp}`;
};

// Helper function to get category image URL
export const getCategoryImageUrl = (category) => {
  if (!category || !category.image_path) return null;

  const timestamp = new Date().getTime();

  // Use localhost for images since we have them locally
  return `${IMAGE_BASE_URL}${category.image_path}?t=${timestamp}`;
};

export default config;
